export default __webpack_public_path__ + "static/media/help-icon.0b97fe2f.svg";